// src/properties/propertyGroupsApi.ts
import { apiClient } from "@maat/api-base";
var propertyGroupsApi = {
  getGroups: async (params) => {
    return apiClient.get("/main/api/property-groups", { params });
  },
  /** One group with its properties and its assigned members. */
  getGroup: async (groupId) => {
    return apiClient.get(`/main/api/property-groups/${groupId}`);
  },
  createGroup: async (data) => {
    return apiClient.post("/main/api/property-groups", data);
  },
  /**
   * A present `property_ids` REPLACES the group's property set, and the backend
   * then auto-revokes every member who loses access with a removed property.
   * Omit the key to edit name/description alone.
   */
  updateGroup: async (groupId, data) => {
    return apiClient.put(`/main/api/property-groups/${groupId}`, data);
  },
  deleteGroup: async (groupId) => {
    return apiClient.delete(`/main/api/property-groups/${groupId}`);
  },
  assignUsers: async (groupId, userIds) => {
    return apiClient.post(`/main/api/property-groups/${groupId}/assign`, { user_ids: userIds });
  },
  /** Singular `user_id` — the unassign route takes one user, unlike assign. */
  unassignUser: async (groupId, userId) => {
    return apiClient.post(`/main/api/property-groups/${groupId}/unassign`, { user_id: userId });
  }
};

export {
  propertyGroupsApi
};
